module.exports = __webpack_public_path__ + "static/media/Festival2.5b4e8f9b.png";